export const isComputedField = (fieldName: string, computedFields: Readonly<string[]>): boolean => {
  return computedFields.includes(fieldName);
};
